export default "__VITE_PUBLIC_ASSET__261fc880__"